import { cn } from '../cn';
import {
  NOTIFICATION_TOGGLE_BASE_CLASS,
  NOTIFICATION_TOGGLE_DISABLED_CLASS,
  NOTIFICATION_TOGGLE_ENABLED_CLASS,
} from './notification-styles';

type NotificationToggleProps = {
  checked: boolean;
  disabled?: boolean;
  label: string;
  onCheckedChange: (checked: boolean) => void;
};

export function NotificationToggle({
  checked,
  disabled = false,
  label,
  onCheckedChange,
}: NotificationToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-label={label}
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      className={cn(
        NOTIFICATION_TOGGLE_BASE_CLASS,
        checked
          ? NOTIFICATION_TOGGLE_ENABLED_CLASS
          : NOTIFICATION_TOGGLE_DISABLED_CLASS,
        'disabled:pointer-events-none'
      )}
    >
      <span className="bg-surface-pure size-6 rounded-full shadow-sm" />
    </button>
  );
}
